import React from 'react';
import ReactDOM from "react-dom";
import Nav from './Nav';
import Hero from './Hero';
import Card from './Card';
import Fade from 'react-reveal/Fade';

// import Kynda from '../img/Kynda.png';
// import Phys from '../img/phys.png';
// import Habitat from '../img/Habitat.png';
import works from '../works';
import sideProjects from '../sideProjects';
import {
    BrowserRouter as Router,
    Route,
    Link,
  } from "react-router-dom";


class App extends React.Component {

      
    
   state = {
       sideProjects:sideProjects,
       works:works,
    };

    
 
    getCardInfo = (current, key, next) => {  
        var current = current
        var next = this.state.works[next]
        this.setState({nextWork: next})
        var work = this.state.works[key]
    }
    getSideProjectCardInfo = (current, key, next) => {  
        var current = current
        var next = this.state.sideProjects[next]
        this.setState({nextWork: next})
        var work = this.state.sideProjects[key]
    }

  
      componentDidMount() {
        window.scrollTo(0, 0)
        window.addEventListener('scroll', this.onScroll, true);
      }

 


  
   
    render(){ 
        let works = this.state.works;
        let sideProjects = this.state.sideProjects;
        
        return (
            <React.Fragment >
                <div id="myBody" >

             <Nav/>
             
             <Hero/>
             <Fade cascade big delay={200}>
             <div className="section">Recent Work</div>
             </Fade>
            
  
             <div className="worksWrapper" id="height">
             <Fade cascade big delay={200}>


                {Object.keys(works).map((current, key, element) => 
                <Link to={`/works/${works[current].slug}`}>
                    <Card key={current} index={current} current={key}  element={element} onClick={this.getCardInfo} details={this.state.works[current]} onMouseOver={this.onHover} mouseLeave={this.mouseLeave}/>
                </Link>
               
                 )}

                 
                  </Fade>
             </div> 

             <div className="section">Side Projects</div>
             <div className="worksWrapper">
             <Fade cascade big delay={200}>
             {Object.keys(sideProjects).map((current, key, element) => 
                <Link to={`/sideprojects/${sideProjects[current].slug}`}>
                 <Card key={current} index={current} current={key}  element={element} onClick={this.getSideProjectCardInfo} details={this.state.sideProjects[current]} onMouseOver={this.onHover} mouseLeave={this.mouseLeave}/>
                </Link>)}
              </Fade>
            </div>
<div className="footer">
            <div className="section">
            <Fade delay={200}>
                <h1 className="filledHeading">
                    Interested in working with me or know more about my projects?
                </h1>
                </Fade>
                <Fade cascade big delay={200}>
                <div className="socials">
                    <a href="mailto:joaocostajjsc@gmail.com" target="_blank">
                    <img src="/img/email.svg" alt=""/>
                    </a>
                    <a href="https://github.com/joaocostajs" target="_blank">
                    <img src="/img/github.svg" alt=""/>
                    </a>
                    <a href="https://twitter.com/joaocostajjsc" target="_blank">
                    <img src="/img/twitter.svg" alt=""/>
                    </a>
                    <a href="https://www.instagram.com/joaojscosta/" target="_blank">
                    <img src="/img/insta.svg" alt=""/>
                    </a>
                </div>
                </Fade>
            </div>
           
            </div>

            



                </div>
                <div className="developer">
                <Fade delay={200}>
                <p>Websited developed by João Costa with ReactJS</p>
                </Fade>
            </div>
            </React.Fragment>
        );
    } 
}

export default App;

